// extracted by mini-css-extract-plugin
module.exports = {"root":"NoResults_root__3j4Nx","icon":"NoResults_icon__2imIZ","message":"NoResults_message__3eebP"};